import { UntypedFormControl, ValidationErrors } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, delay, map, take, tap } from "rxjs/operators";
import { ProductCaptureService } from "../../services/product-capture.service";

export function validateIsin(service: ProductCaptureService, controlName: string): (group: UntypedFormControl) => Observable<ValidationErrors | null> {
    let initialValue = null;

    return (control: UntypedFormControl): Observable<ValidationErrors | null> => {
        const { value } = control;
        
        if ((initialValue && initialValue === value) || !value?.trim().length) {
            return of(null).pipe(take(1));
        }
        
        if (!initialValue) {
            initialValue = value;
        }
        
        const isin = controlName === 'isin' ? value : null;

        return service.checkForExistingIsin(isin)
            .pipe(
                tap(() => control.setErrors(null)),
                delay(1000),
                debounceTime(500),
                map((data: any) => {
                    const valid = data[controlName];
                    if (initialValue === value && !valid) {
                        initialValue = null;
                    }
                    return valid ? null : { notUnique: !valid };
                })
            );
    }
}